import React from "react";

/**
 * Pram Express vendor portal — slim footer.
 * (The old offcanvas "Operational" mega-menu linked to admin-portal routes
 * that do not exist in this app; it has been removed. Policy links live on
 * the login page.)
 */
function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="px-footer">
            <span>Pram Express · Courier &amp; Hyperlocal Delivery</span>
            <span>© {year} Pram Express. All rights reserved.</span>
        </footer>
    );
}

export default Footer;
